/**
 * CachedEditorHtml — renders cached docHtml outside a live TipTap editor.
 *
 * Returns null when the document is empty (no placeholder shown — the real
 * TipTap placeholder only appears on focus).
 * Non-empty HTML is normalized so empty `<p>` tags don't collapse to 0px.
 */

import DOMPurify from "dompurify"
import { normalizeEmptyParagraphs, isEmptyDocHtml } from "./normalizeEmptyParagraphs"

interface CachedEditorHtmlProps {
  docHtml: string | undefined
  className?: string
}

export function CachedEditorHtml({ docHtml, className }: CachedEditorHtmlProps) {
  if (isEmptyDocHtml(docHtml)) return null

  return (
    <div className={`tiptap ProseMirror py-2 ${className ?? ""}`} aria-hidden>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(normalizeEmptyParagraphs(docHtml!)) }} />
    </div>
  )
}
